import React, { PropsWithChildren } from 'react'

import Sidebar from '@/components-latest/layout/Sidebar'

import Styles from './PrivateLayout.module.scss'

const PrivateLayout: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={Styles.privateLayout} data-testid="private-layout">
      <Sidebar />
      <div className={Styles.content}>{children}</div>
    </div>
  )
}

export default PrivateLayout
